import React, { useEffect, useState } from 'react'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'

import useText from '../common/hooks/useText'
import { formatTime } from '../common/uikit/Scheduler'
import { ScheduleEntry } from '../common/uikit/Scheduler/types'

import CurrentSelect from './CurrentSelect'
import Text from './Text'

export default function ScheduledTimeSlotEditorModal({
    minPossibleCurrent,
    maxPossibleCurrent,
    selectedSchedulePeriod,
    isSocket,
    visible,
    onHide,
    onSave,
}: Props): React.ReactElement {
    const text = useText()

    const [currentValue, setCurrent] = useState(selectedSchedulePeriod?.maxCurrent)

    useEffect(() => {
        if (selectedSchedulePeriod) {
            setCurrent(selectedSchedulePeriod.maxCurrent)
        }
    }, [selectedSchedulePeriod])

    const label = selectedSchedulePeriod
        ? `${formatTime(selectedSchedulePeriod.from)} - ${formatTime(selectedSchedulePeriod.to)}`
        : null

    return (
        <Dialog
            header={label}
            visible={visible}
            onHide={onHide}
            footer={
                <div>
                    <Button
                        outlined
                        label={text('btnCancel')}
                        onClick={onHide}
                        icon="pi pi-times"
                        data-testid="cancel-btn"
                    />
                    <Button
                        label={text('btnApply')}
                        onClick={() => {
                            onSave({ ...selectedSchedulePeriod, maxCurrent: currentValue })
                        }}
                        data-testid="save-btn"
                        icon="pi pi-check"
                    />
                </div>
            }
            style={{ width: '40vw' }}
            breakpoints={{ '960px': '75vw', '641px': '100vw' }}
        >
            {isSocket ? (
                <div style={{ fontSize: '14px', fontWeight: 600, padding: '15px 0' }}>
                    <Text code="lblSocketChargingStatus" values={{ isOn: !!selectedSchedulePeriod?.maxCurrent }} />
                </div>
            ) : (
                <div className="flex gap-3 align-items-center">
                    <CurrentSelect
                        label={text('msgApplyCurrentToThisChargingSchedule')}
                        value={currentValue || 0}
                        minValue={minPossibleCurrent}
                        maxValue={maxPossibleCurrent}
                        onChange={({ value }) => {
                            if (typeof value === 'number') {
                                setCurrent(value)
                            }
                        }}
                        placeholder={text('lblSelectOption')}
                        error={typeof currentValue !== 'number' ? text('msgMaxCurrentRequired') : undefined}
                    />
                </div>
            )}
        </Dialog>
    )
}

export type Props = {
    minPossibleCurrent?: number
    maxPossibleCurrent?: number
    visible: boolean
    onHide: () => void
    onSave: (schedulePeriod: ScheduleEntry) => void
    selectedSchedulePeriod: ScheduleEntry | null
    isSocket?: boolean
}
